<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-vacuum-war">
<h1>The Vacuum War</h1>
<p style="text-indent:0em">It’s like being thrown into a deep pool with hands tied.</p>
<p style="text-indent:0em">It’s like throwing hard punches at nothing.</p>
<p style="text-indent:0em">It’s like an engulfing darkness.</p>
<p style="text-indent:0em">You never see your enemy.</p>
<p style="text-indent:0em">You never know where the bullets come from.</p>
<p style="text-indent:0em">You only know that this is war!</p><br/>
<p style="text-indent:0em">There’s no time to sit and plan a counterattack.</p>
<p style="text-indent:0em">There’s nowhere to hide.</p>
<p style="text-indent:0em">There’s no helping hand in sight.</p>
<p style="text-indent:0em">No one hears your cries, no one knows you are in a vacuum,</p>
<p style="text-indent:0em">Even if anyone did, there’s no chance you’d get help.</p><br/>
<p style="text-indent:0em">They have the upper hand</p>
<p style="text-indent:0em">You are greatly disadvantaged</p>
<p style="text-indent:0em">They are the best battalion</p>
<p style="text-indent:0em">Made up of the best soldiers</p>
<p style="text-indent:0em">Led by the Greatest commander</p>
<p style="text-indent:0em">You are ALONE.</p><br/>
<p style="text-indent:0em">You are tired.</p>
<p style="text-indent:0em">They know it and use it to their advantage</p>
<p style="text-indent:0em">You wish they just strike you down</p>
<p style="text-indent:0em">But they won’t, not until you go crazy with fatigue</p>
<p style="text-indent:0em">Then maybe then, the war will end.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?6384f217